interface DonationAmountButtonsProps {
  /** The preset gift buttons to render, in order. */
  amounts: number[];
  /** The currently-selected amount as a string ('' when none), so it round-trips with the "other amount" input. */
  selected: string;
  /** Called with the clicked amount as a string. */
  onSelect: (value: string) => void;
  /** Group label for assistive tech. */
  ariaLabel?: string;
}

/**
 * The suggested-gift preset grid, shared by the live donor form (step 1) and the admin "Advanced
 * settings" live preview — so the admin sees exactly what donors will. Presentational only: the caller
 * owns the amounts (custom or default, already resolved) and the selection state.
 */
export function DonationAmountButtons({
  amounts,
  selected,
  onSelect,
  ariaLabel = 'Suggested gifts',
}: DonationAmountButtonsProps) {
  return (
    <div className="grid grid-cols-2 gap-2" aria-label={ariaLabel}>
      {amounts.map((suggestedAmount, index) => {
        const isSelected = selected === String(suggestedAmount);
        return (
          // Composite key: the live preview can transiently hold duplicate amounts mid-edit (which the
          // editor then flags), so the index keeps keys unique without affecting the donor form.
          <button
            key={`${suggestedAmount}-${index}`}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelect(String(suggestedAmount))}
            className="donation-amount-choice"
            data-selected={isSelected || undefined}
          >
            ${suggestedAmount}
          </button>
        );
      })}
    </div>
  );
}
